import { render, staticRenderFns } from "./ModalAddGestores.vue?vue&type=template&id=8139ab98"
import script from "./ModalAddGestores.vue?vue&type=script&lang=ts"
export * from "./ModalAddGestores.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports